module.exports = __webpack_public_path__ + "img/2_194.61f626a1.png";